<template>
<v-app id='auth-view'>
  <v-content id="auth-view-container">
    <v-img :src="backgroundImage" height="100%" />
    <transition name="slide-fade">
      <router-view></router-view>
    </transition>
  </v-content>
</v-app>
</template>

<script>
import backgroundImage from '../assets/backgrounds/login-bkgd.png'
export default {
  name: 'AuthView',
  data() {
    return {
      windowSize: this.$store.state.windowSize,
      backgroundImage: backgroundImage
    }
  }
}
</script>

<style scoped>
#auth-view {
  font-family: 'BebasNeueRegular';
}
#auth-view-container {
  height: 100%;
  width: 100%;
}
#auth-view .v-image {
  opacity: 1;
}

.slide-fade-enter-active {
  transition: all 300ms ease-out;
}
.slide-fade-leave-active {
  transition: all 500ms ease-in;
}
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
.slide-fade-leave
/* .slide-fade-leave-active below version 2.1.8 */ {
  
  opacity: 1
}
.slide-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  
  opacity: 0
}
.slide-fade-enter-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  opacity: 1
}

</style>
